export enum LanguageEnum {
  English = 'EN',
  Spanish = 'ES',
}